import { useContext } from 'react';

import { SurveyCtx } from '@r1-frontend/survey/context';
import { SurveyInitialState } from '@r1-frontend/survey/context/reducer/initialState';

const useCtxSelector = <T>(selector: (state: SurveyInitialState) => T) => {
    const { state } = useContext(SurveyCtx);

    return selector(state);
};

export default useCtxSelector;
